import { Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { ApiService } from '../../../../services/api.service';

@Component({
  selector: 'app-elimina-canale-backoffice',
  templateUrl: './elimina-canale-backoffice.component.html',
  styleUrls: ['./elimina-canale-backoffice.component.css']
})
export class EliminaCanaleBackofficeComponent {

  constructor(private apiService: ApiService) { }

  loading: boolean = false;

  readonly #modal = inject(NzModalRef);
  readonly nzModalData = inject(NZ_MODAL_DATA);

  onElimina() {
    this.loading = true;

    // Elimino il canale
    this.apiService.deleteCanale(this.nzModalData.id_canale!).subscribe({
      next: (data) => this.apiService.setCanali(),
      error: (err) => {
        this.loading = false;
        this.apiService.error(err.error.message);
      }, complete: () => {
        this.loading = false;
        this.#modal.destroy();
      }
    })
  }

  onClose() {
    this.#modal.destroy();
  }
}